import { Translator } from '../../../Core/js/common/adapters/legacy-to-modules-adapter';

document.addEventListener('DOMContentLoaded', () => {
  const passwordInput = document.getElementById('password');
  const toggleIcon = document.getElementById('toggle-password');

  if (!passwordInput || !toggleIcon) {
    return;
  }

  toggleIcon.addEventListener('click', () => {
    const isPasswordVisible = passwordInput.type === 'text';

    passwordInput.type = isPasswordVisible ? 'password' : 'text';
    toggleIcon.classList.toggle('fa-eye', isPasswordVisible);
    toggleIcon.classList.toggle('fa-eye-slash', !isPasswordVisible);
    toggleIcon.title = Translator.trans(isPasswordVisible ? 'Show password' : 'Hide password');
  });
});



// WEBPACK FOOTER //
// ./assets/User/js/app/login.js